<div class="main-content">
    <div class="row">

        <div class="col-12 ">
            <mat-card style="box-shadow: none !important;">
                <mat-card-content style="padding: 15px;">
                    <div class="container mainContentNew">
                        <div>
                            <h2>Support</h2>
                        </div>

                        <div class="d-flex justify-content-between d-none d-md-none d-lg-flex">
                            <span class="d-block" style="color: #979797; width: 70%">
                                Manage your certifications and track CEUs with ease
                            </span>
                            <ul class="breadcrumb d-none d-sm-none d-md-none d-lg-flex">
                                <li class="active"><a [routerLink]="['/dashboard/home']">Dashboard</a></li>
                                <li class="separator">/</li>
                                <li><a style="color: #000" href="#">Support</a></li>
                            </ul>
                        </div>

                        <hr style="height: 1px; background: #ccc; border: none"/>
                    </div>
                    <div class="container contact-form">

                        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" #tabGroup>
                            <mat-tab label="Ticket History">
                                <h4 class="my-5">Message History</h4>
                                <div class="text-end justify-content-end mb-3" >
                                    <button mat-raised-button style="background:#5B25B4; color: #fff;" (click)="goToNewTicket()">Create New Ticket</button>
                                </div>
                                <div class="table-responsive list-wrapper-bordered">
                                    <table class="table table-striped table-hover table-borderless border-0 ">
                                        <thead>
                                        <tr>
                                            <th class="text-nowrap">Ticket ID</th>
                                            <th class="text-nowrap">Date</th>
                                            <th class="text-nowrap">Email</th>
                                            <th class="text-nowrap">Subject</th>
                                            <th class="text-nowrap">Status</th>
                                            <th class="text-nowrap">Last Update</th>
                                            <th class="sticky-action"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr *ngFor="let msg of messages">
                                            <td class="text-nowrap" style="color: #000;">#{{ msg.id }}</td>
                                            <td class="text-nowrap"
                                                style="color: #000;">{{ msg.openAt | date : "MM/dd/y hh:mm:ss" }}
                                            </td>
                                            <td class="text-nowrap" style="color: #000;">{{ msg.email }}</td>
                                            <td style="color: #000;" class="ellipsis">{{ msg.messageSubject }}</td>
                                            <td class="text-nowrap" style="color: #000;">
                                                <mat-chip *ngIf="msg.status == 'OPEN'" style="background:#F0E7BE;">
                                                    {{maskingColumn('parameterLabel', 'parameterValue', ticketStatus.parameterMembers, msg.status)}}
                                                </mat-chip>
                                                <mat-chip *ngIf="msg.status == 'CLOSED'" style="background: #BEF0CA">
                                                    {{maskingColumn('parameterLabel', 'parameterValue', ticketStatus.parameterMembers, msg.status)}}
                                                </mat-chip>
                                            </td>
                                            <td class="text-nowrap"
                                                style="color: #000;">{{ date.timeAgo(msg.updatedAt) }}
                                            </td>
                                            <td class="sticky-action">
                                                <button (click)="conversation(msg.id)"
                                                        style="background:#5B25B4; color: #fff;" mat-raised-button
                                                        aria-label="view message">
                                                    View Message
                                                </button>
                                            </td>
                                        </tr>
                                        <tr *ngIf="messages.length == 0">
                                            <td colspan="7" class="text-center">
                                                <span>No Record</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="mt-4" *ngIf="messages.length > 0">
                                    <app-pagination
                                            (goPage)="toPage($event)"
                                            [pagesToShow]="showPages"
                                            [page]="pageNo"
                                            [perPage]="pageSize"
                                            [count]="totalRow"></app-pagination>
                                </div>

                            </mat-tab>
                            <mat-tab label="New Ticket">
                                <h4 class="my-3">Message Support Team</h4>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <div style="height: 50vh; overflow-y: scroll; overflow-x: hidden">
                                            <form [formGroup]="form">
                                                <div class="row mt-2">
                                                    <div class="col-12 col-md-12 col-sm-12 col-lg-6">
                                                        <mat-form-field class="full-width w-100" appearance="outline">
                                                            <mat-label>Your Name</mat-label>
                                                            <input type="text" matInput formControlName="name">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-12 col-md-12 col-sm-12 col-lg-6">
                                                        <mat-form-field class="full-width w-100" appearance="outline">
                                                            <mat-label>Your Email Address</mat-label>
                                                            <input type="email" matInput formControlName="email">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-12">
                                                        <mat-form-field class="full-width w-100" appearance="outline">
                                                            <mat-label>Subject</mat-label>
                                                            <input type="text" matInput formControlName="subject">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <button (click)="hasAttachment = !hasAttachment" type="button"
                                                                mat-raised-button color="primary">
                                                            <mat-icon>attachment</mat-icon>
                                                            {{hasAttachment ? 'Cancel' : 'Add'}} Attachment (Optional)
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="row mt-3" *ngIf="hasAttachment">
                                                    <div class="col-12">
                                                        <app-upload-single
                                                                (fileChange)="getFileChange($event)"
                                                                [accept]="'image/*,application/pdf'"
                                                                [fileUrl]="fileUrl"
                                                                [labelButton]="'Browse File'"
                                                                [label]="'Upload Attachment (Optional)'"
                                                                [readonly]="uploading">

                                                        </app-upload-single>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-12">
                                                        <mat-form-field class="full-width w-100" appearance="outline">
                                                            <mat-label>Your Message</mat-label>
                                                            <textarea formControlName="msg" matInput
                                                                      placeholder="Type here..." rows="4"></textarea>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="d-none d-sm-none d-md-none d-lg-block text-end pb-5">

                                                        <button [disabled]="uploading" type="button" mat-raised-button color="accent"
                                                                style="margin-right: 10px;" (click)="tabGroup.selectedIndex = 0;">Cancel
                                                        </button>

                                                        <button [disabled]="uploading" type="button" mat-raised-button color="primary"
                                                                style="margin-right: 10px;" (click)="resetForm()">Reset
                                                        </button>

                                                        <button [disabled]="uploading" type="button" mat-raised-button color="primary"
                                                                (click)="save()" style="background:#5B25B4; color: #fff;">
                                                            <mat-icon>add</mat-icon>
                                                            Create New Ticket
                                                        </button>
                                                </div>

                                                <div class="d-block d-sm-block d-md-block d-lg-none">
                                                    <div class="row mt-3 ">
                                                        <div class="col-12 col-md-12 col-sm-12 col-lg-4 mt-2">
                                                            <button class="w-100" [disabled]="uploading" type="button" mat-raised-button color="accent"
                                                                    style="margin-right: 10px;" (click)="tabGroup.selectedIndex = 0;">Cancel
                                                            </button>
                                                        </div>
                                                        <div class="col-12 col-md-12 col-sm-12 col-lg-4 mt-2">
                                                            <button class="w-100" [disabled]="uploading" type="button" mat-raised-button color="primary"
                                                                    style="margin-right: 10px;" (click)="resetForm()">Reset
                                                            </button>
                                                        </div>
                                                        <div class="col-12 col-md-12 col-sm-12 col-lg-4 mt-2">
                                                            <button [disabled]="uploading" type="button" mat-raised-button color="primary" class="w-100"
                                                                    (click)="save()" style="background:#5B25B4; color: #fff;">
                                                                <mat-icon>add</mat-icon>
                                                                Create New Ticket
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </mat-tab>
                        </mat-tab-group>

                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

